import { Action, createReducer, on } from '@ngrx/store';
import {
  getCompanySettingsAction, getCompanySettingsSuccessAction, getCompanySettingsFailureAction,
} from './get-company-settings.actions';
import { GetCompanySettingsState } from './get-company-settings.types';

const initialState = {
  loading: false,
  loaded: false,
  data: undefined,
  error: null,
};

const getCompanySettingsReducer = createReducer<GetCompanySettingsState>(
  initialState,
  on(
    getCompanySettingsAction,
    state => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),
  on(
    getCompanySettingsSuccessAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      data: action.data,
      error: null,
    })
  ),
  on(
    getCompanySettingsFailureAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: GetCompanySettingsState, action: Action) => getCompanySettingsReducer(state, action);
